// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <polygon points="9.8,17.2 9,16.5 13.9,11.6 9,6.7 9.8,6 15.4,11.6" />
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-chevron-right-Ca_EBQ4S.js.map
